import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImageCarousel } from '../../../../components/imageCarousel/imageCarousel';
import players from '../../../../assets/img/Players.png';
import teamManager from '../../../../assets/img/TeamManager.png';
import automaticNotifications from '../../../../assets/img/AutomaticNotifications.png';
import guardianTelehealthAppt from '../../../../assets/img/GuardianTelehealthAppt.png';

export const OnboardingDesktop = () => {
  const { t } = useTranslation();

  const items = [
    { image: players, text: t('onboarding.ONBOARDING_1') },
    { image: teamManager, text: t('onboarding.ONBOARDING_2') },
    { image: automaticNotifications, text: t('onboarding.ONBOARDING_3') },
    { image: guardianTelehealthAppt, text: t('onboarding.ONBOARDING_4') },
  ];
  return <ImageCarousel items={items} />;
};
